import React, { useMemo } from 'react';
import { Text } from '@atlaskit/primitives';

export const CreateCustomerAndBillingProfileHeader = ({
  formStage,
  isAddNewAddressFlow,
}: {
  formStage: number;
  isAddNewAddressFlow?: boolean;
}) => {
  const title = useMemo(() => {
    if (isAddNewAddressFlow) {
      if (formStage === 0 || formStage === 1) {
        return 'Add customer details';
      }
      if (formStage === 2) {
        return 'Add partner details';
      }
      if (formStage === 3) {
        return 'Finalize';
      }
    } else {
      if (formStage === 0) {
        return 'Company name';
      }
      if (formStage === 1) {
        return 'Add customer details';
      }
      if (formStage === 2 || formStage === 3) {
        return 'Create billing profile';
      }
      if (formStage === 4) {
        return 'Finalize';
      }
    }
  }, [formStage]);

  return title ? (
    <Text weight="semibold" id="create-customer-header">
      {formStage + 1}. {title}
    </Text>
  ) : null;
};
